/*
 * Подпись под незаполненным обязательным (дизайн-система 3.3, `.missing-note`):
 * «Обязательное поле» либо, для действия без которого форму не отправить,
 * «Обязательное действие».
 */

export function MissingNote({ action }: { action?: boolean }) {
  return <span className="missing-note">{action ? 'Обязательное действие' : 'Обязательное поле'}</span>;
}
